// extracted by mini-css-extract-plugin
export default {"projectPage":"ProjectPage_projectPage__AvIfI","tabsPanel":"ProjectPage_tabsPanel__zPEiG"};